module.exports = __webpack_public_path__ + "static/61035836_1350173638466524_4209461180105752576_n_optimized-8e43c1d3f53a307707ca60fadcd508fd.jpg";